/**
 * @generated SignedSource<<3432ad567a0db7656508c7ac084b6d67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type partnerTemplateCardContentfulRelayFragment$data = {
  readonly oneLinerHeadline: string | null | undefined;
  readonly sys: {
    readonly id: string;
  };
  readonly templateNameExternal: string | null | undefined;
  readonly urlSlug: string | null | undefined;
  readonly " $fragmentType": "partnerTemplateCardContentfulRelayFragment";
};
export type partnerTemplateCardContentfulRelayFragment$key = {
  readonly " $data"?: partnerTemplateCardContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"partnerTemplateCardContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "partnerTemplateCardContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sys",
      "kind": "LinkedField",
      "name": "sys",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oneLinerHeadline",
      "storageKey": null
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};

(node as any).hash = "ca73d5016af7e32a730f30a64afc6a76";

export default node;
